<template>
    <div>
        <div class="card card-default">
            <div class="card-header">
                <div class="fw-600 float-left font-size-large">Team members & Subcontractors</div>
                <div v-if="loading" class="float-right">
                    <span class="loader loader-sm"></span>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-valign-middle mb-0">
                    <thead>
                        <th class="th-fit"></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>&nbsp;</th>
                    </thead>
                    <tbody>
                        <tr v-for="crewMember in crew" :key="crewMember.id">
                            <td>
                                <div class="btn-table-align">
                                    <img :src="crewMember.photo_url" class="crew-profile-photo" />
                                </div>
                            </td>

                            <td>
                                <div class="btn-table-align">
                                    {{ crewMember.name }}
                                </div>
                            </td>

                            <td>
                                <div class="btn-table-align">
                                    {{ crewMember.email }}
                                </div>
                            </td>

                            <td>
                                <div class="btn-table-align">
                                    {{ teamMemberRole(crewMember) }}
                                </div>
                            </td>

                            <td class="td-fit">
                                <button class="btn btn-outline-primary" @click="editTeamMember(crewMember)" v-if="roles.length > 1 && canEditTeamMember(crewMember)">
                                    <i class="fa fa-cog"></i>
                                </button>

                                <button class="btn btn-outline-danger" @click="approveTeamMemberDelete(crewMember)" v-if="canDeleteTeamMember(crewMember)">
                                <i class="fa fa-user-minus"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Update Team Member Modal -->
        <div class="modal" id="modal-update-team-member" tabindex="-1" role="dialog">
            <div class="modal-dialog" v-if="updatingTeamMember">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Update {{ updatingTeamMember.name }}
                        </h5>
                    </div>

                    <div class="modal-body">
                        <!-- Update Team Member Form -->
                        <form role="form">
                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">
                                    Role
                                </label>

                                <div class="col-md-6">
                                    <select class="form-control" v-model="updateTeamMemberForm.role" :class="{'is-invalid': updateTeamMemberForm.errors.has('role')}">
                                        <option v-for="role in roles" :value="role.value" :key="role.value">
                                            {{ role.text }}
                                        </option>
                                    </select>

                                    <span class="invalid-feedback" v-if="updateTeamMemberForm.errors.has('role')">
                                        {{ updateTeamMemberForm.errors.get('role') }}
                                    </span>
                                </div>
                            </div>
                        </form>
                    </div>

                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>

                        <button type="button" class="btn btn-primary" @click="update" :disabled="updateTeamMemberForm.busy">
                            Save changes
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Delete Team Member Modal -->
        <div class="modal" id="modal-delete-member" tabindex="-1" role="dialog">
            <div class="modal-dialog" v-if="deletingTeamMember">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Remove {{ deletingTeamMember.name }} from crew
                        </h5>
                    </div>

                    <div class="modal-body">
                        Are you sure you want to remove <strong>{{ deletingTeamMember.name }}</strong> from your team?
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Nevermind, do not remove</button>

                        <button type="button" class="btn btn-danger" @click="deleteMember" :disabled="deleteTeamMemberForm.busy">
                            Yes, remove
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'project'],

        mounted: function() {

        },

        /**
         * The component's data.
         */
        data: function() {
            return {
                loading: true,
                crew: [],
                team: [],
                roles: [],
                updatingTeamMember: null,
                deletingTeamMember: null,
                updateTeamMemberForm: new SparkForm({
                    role: ''
                }),
                deleteTeamMemberForm: new SparkForm({})
            };
        },

        computed: {
            /**
             * Get the URL for updating a team member.
             */
            urlForUpdating: function () {
                return `/api/crew/${this.updatingTeamMember.id}`;
            },


            /**
             * Get the URL for deleting a team member.
             */
            urlForDeleting() {
                return `/api/crew/${this.deletingTeamMember.id}`;
            },
        },

        watch: {
            project: function (newProject, oldProject) {
                this.refresh();
            }
        },

        /**
         * The component has been created by Vue.
         */
        created: function() {
            this.getCrew();
            this.getCrewRoles();
        },

        methods: {
            getCrew: function() {
                axios.get(`/api/crew`)
                    .then(response => {
                        this.loading = false;
                        this.crew = response.data.crew;
                        this.team = response.data.team;
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log('Something went wrong getting the crew:');
                        console.log(error);
                    });
            },

            getCrewRoles: function() {
                axios.get('/api/crew/roles')
                    .then(response => {
                        this.roles = response.data;
                    });
            },

            refresh: function() {
                this.loading = true;
                this.getCrew();
                this.getCrewRoles();
            },

            /**
             * Edit the given team member.
             */
            editTeamMember(member) {
                this.updatingTeamMember = member;
                this.updateTeamMemberForm.role = member.pivot.role;
                $('#modal-update-team-member').modal('show');
            },


            /**
             * Update the team member.
             */
            update() {
                this.loading = true;
                Spark.put(this.urlForUpdating, this.updateTeamMemberForm)
                    .then(() => {
                        Bus.$emit('updateTeam');
                        $('#modal-update-team-member').modal('hide');
                        this.refresh();
                    });
            },

            /**
             * Display the approval modal for the deletion of a team member.
             */
            approveTeamMemberDelete(member) {
                this.deletingTeamMember = member;
                $('#modal-delete-member').modal('show');
            },


            /**
             * Delete the given team member.
             */
            deleteMember() {
                this.loading = true;
                Spark.delete(this.urlForDeleting, this.deleteTeamMemberForm)
                    .then(() => {
                        Bus.$emit('updateTeam');
                        $('#modal-delete-member').modal('hide');
                        this.refresh();
                    });
            },


            /**
             * Determine if the current user can edit a team member.
             */
            canEditTeamMember(member) {
                return this.user.id === this.team.owner_id && this.user.id !== member.id
            },


            /**
             * Determine if the current user can delete a team member.
             */
            canDeleteTeamMember(member) {
                return this.user.id === this.team.owner_id && this.user.id !== member.id
            },

            /**
             * Get the displayable role for the given team member.
             */
            teamMemberRole(member) {
                if (this.roles.length == 0) {
                    return '';
                }

                if (member.pivot.role == 'owner') {
                    return 'Owner';
                }

                const role = _.find(this.roles, role => role.value == member.pivot.role);

                if (typeof role !== 'undefined') {
                    return role.text;
                }
            }
        }
    }
</script>
